import React, { useState, useEffect } from 'react'
import { Query } from 'react-apollo'
import { useMutation, useQuery } from '@apollo/react-hooks'
import moment from 'moment'
import ReactTable from 'react-table'
import {
 Modal, DatePicker, Select, Dropdown, Menu, Icon, Row, Col, Button as AntdButton, message,
} from 'antd'
import _ from 'lodash'
import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  Div, H3, Button, Loading, DynamicButtonLink, P, Input,
} from 'konsys-ui'
import config from './config'
import { status, statusText } from '../constants'
import { theme } from '../../../styles/_variables'
import './style-css.css'
import { Wrapper } from '../../../components/truck-components'
import { GET_TRUCK_LIST, GET_FLEETS, GET_TRUCK_BRAND_LIST } from '../../../constants/graphql/query'
import { UPDATE_TRUCK_BRANDS } from '../../../constants/graphql/mutation'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { monthConverter, checkFloat } from '../../../utils/util-services'
import PERMISSION from '../../../constants/permissions'

const { color } = theme

const FuelConsumptionRateModal = ({
  fuelConsumptionRateModal, setFuelConsumptionRateModal,
}) => {
  const [truckBrands, setTruckBrands] = useState([])
  const {
    data: truckBrandData, loading: truckBrandLoading,
  } = useQuery(GET_TRUCK_BRAND_LIST, { skip: !_.includes(window.perms, PERMISSION.UPDATE_TRUCK) })
  const [doUpdateBrand, { loading: updateBrandLoading }] = useMutation(UPDATE_TRUCK_BRANDS)

  useEffect(() => {
    if (truckBrandData?.TruckBrandList?.lists) setTruckBrands(truckBrandData?.TruckBrandList?.lists)
  }, [truckBrandData])
  return (
    <Modal
      title='แก้ไขอัตราการเผาผลาญน้ำมัน'
      visible={fuelConsumptionRateModal}
      destroyOnClose={true}
      onCancel={() => {
        setFuelConsumptionRateModal(false)
        setTruckBrands(truckBrandData?.TruckBrandList?.lists || [])
      }}
      onOk={() => {
        doUpdateBrand({
          variables: {
            brands: truckBrands.map(brand => _.pick(brand, ['id', 'name', 'fuelConsumptionRate'])),
          },
          refetchQueries: ['TruckBrandList'],
        }).then((resp) => {
          const response = resp.data.UpdateTruckBrands
          if (response.success) {
            message.success(response.message)
            setFuelConsumptionRateModal(false)
            setTruckBrands(truckBrandData?.TruckBrandList?.lists || [])
          } else message.error(response.message)
        })
      }}
      okButtonProps={{
        disabled: updateBrandLoading
        || _.size(_.filter(truckBrands, o => (_.isUndefined(o.name) && _.isEmpty(o.name)))) > 0,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='column' width='100%'>
          <Row gutter={8} style={{ marginBottom: 8, width: '100%' }} align='middle' type='flex'>
            <Col span={14}>
              <P>ยี่ห้อ *</P>
            </Col>
            <Col span={7}>
              <P>อัตราเผาผลาญ</P>
            </Col>
          </Row>
        {
          truckBrands.map((truckBrand, index) => (
            <Row key={truckBrand.id} gutter={8} style={{ marginBottom: 8, width: '100%' }} align='middle' type='flex'>
              <Col span={14}>
              <Input width='100%' placeholder='ชื่อแบรนด์' value={truckBrand.name} onChange={(e) => {
                  const newTruckBrands = _.cloneDeep(truckBrands)
                  newTruckBrands[index].name = e.target.value
                  setTruckBrands([...newTruckBrands])
                }}
              />
              </Col>
              <Col span={7}>
              <Input type='number' width='100%' placeholder='อัตราเผาผลาญ' value={truckBrand.fuelConsumptionRate} onChange={(e) => {
                  const newTruckBrands = _.cloneDeep(truckBrands)
                  newTruckBrands[index].fuelConsumptionRate = parseFloat(e.target.value, 10) || 0
                  setTruckBrands([...newTruckBrands])
                }}
                onKeyDown={(e) => {
                  if (!checkFloat(e)) {
                    e.preventDefault()
                  }
                }}
              />
              </Col>
              <Col span={3}>
                <P>km / l</P>
              </Col>
            </Row>
          ))
        }
        <AntdButton type="dashed" onClick={() => {
            setTruckBrands([...truckBrands, {
              id: _.maxBy(truckBrands, 'id').id + 1,
            }])
          }}>
            <Icon type="plus" /> เพิ่มยี่ห้อรถ
          </AntdButton>
      </Div>
    </Modal>
  )
}

const RepairExpenseModal = ({
  repairExpenseModal, setRepairExpenseModal, isLoading, setIsLoading,
}) => {
  const [range, setRange] = useState([])
  const [fleetId, setFleetId] = useState('')
  const [fleetName, setFleetName] = useState()
  const {
    data: fleetData, loading: fleetLoading, error: fleetError, refetch: fleetRefetch,
  } = useQuery(GET_FLEETS)
  if (fleetLoading || _.isEmpty(fleetData)) return <Loading />
  return (
    <Modal
      title="พิมพ์ค่าใช้จ่ายของการซ่อมรถบรรทุก"
      visible={repairExpenseModal}
      destroyOnClose={true}
      onCancel={() => {
        setRepairExpenseModal(false)
        setRange([])
        setFleetId()
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/truck/expenseByFleet?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
              `fleetId=${fleetId}`,
            ].join('&')
          }`,
        }).then((resp) => {
          FileDownload(resp.data, `พิมพ์ค่าใช้จ่ายของการซ่อมรถบรรทุกวันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} ของfleet ${fleetName || 'ทั้งหมด'}.xlsx`)
          setIsLoading(false)
          setRepairExpenseModal(false)
          setFleetId('')
          setRange([])
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(range) || _.isUndefined(fleetId),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row'>
        <P margin = '0 32px 0 0'>เลือกวันที่</P>
        <DatePicker.RangePicker
          format='DD/MM/YYYY'
          onChange={(e) => {
            setRange(e)
          }}
        />
      </Div>
      <Div alignItems='center' display='flex' flexDirection='row' margin = '22px 0 0 0'>
        <P margin = '0 29px 0 0'>เลือกfleet</P>
        <Select
        style={{ width: 334 }}
        defaultValue="ทั้งหมด"
        onSelect={(e) => {
          if (e === 'all') {
            setFleetId('')
          } else {
            setFleetId(e)
            setFleetName(_.find(fleetData.FleetList.lists, v => e === v.name))
          }
        }}
      >
        <Select.Option key='all' value='all'>ทั้งหมด</Select.Option>
        {
          fleetData.FleetList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>)
        }
      </Select>
      </Div>
    </Modal>
  )
}

const ChangeTireModal = ({
  changeTireModal, setChangeTireModal, isLoading, setIsLoading,
}) => {
  const [range, setRange] = useState([])
  const [fleetId, setFleetId] = useState('')
  const [fleetName, setFleetName] = useState()
  const {
    data: fleetData, loading: fleetLoading, error: fleetError, refetch: fleetRefetch,
  } = useQuery(GET_FLEETS)
  if (fleetLoading || _.isEmpty(fleetData)) return <Loading />
  return (
    <Modal
      title="พิมพ์รายงานค่ายาง"
      visible={changeTireModal}
      destroyOnClose={true}
      onCancel={() => {
        setChangeTireModal(false)
        setRange([])
        setFleetId()
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/truck/tire/expenseByFleet?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
              `fleetId=${fleetId}`,
            ].join('&')
          }`,
        }).then((resp) => {
          FileDownload(resp.data, `พิมพ์รายงานค่ายางวันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} ของfleet ${fleetName || 'ทั้งหมด'}.xlsx`)
          setIsLoading(false)
          setChangeTireModal(false)
          setFleetId('')
          setRange([])
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(range) || _.isUndefined(fleetId),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row'>
        <P margin = '0 32px 0 0'>เลือกวันที่</P>
        <DatePicker.RangePicker
          format='DD/MM/YYYY'
          onChange={(e) => {
            setRange(e)
          }}
        />
      </Div>
      <Div alignItems='center' display='flex' flexDirection='row' margin = '22px 0 0 0'>
        <P margin = '0 29px 0 0'>เลือกfleet</P>
        <Select
        style={{ width: 334 }}
        defaultValue="ทั้งหมด"
        onSelect={(e) => {
          if (e === 'all') {
            setFleetId('')
          } else {
            setFleetId(e)
            setFleetName(_.find(fleetData.FleetList.lists, v => e === v.name))
          }
        }}
      >
        <Select.Option key='all' value='all'>ทั้งหมด</Select.Option>
        {
          fleetData.FleetList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>)
        }
      </Select>
      </Div>
    </Modal>
  )
}

export const colorSelector = (e) => {
  switch (e) {
    case status.AVAILABLE:
      return color.success
    case status.REPAIRING:
      return color.warning
    case status.IN_USE:
      return color.error
    case status.OUT_OF_SERVICE:
      return color.error
    default:
      return color.charcoalGrey
  }
}

export const textStatusSelector = (e) => {
  switch (e) {
    case status.AVAILABLE:
      return statusText.AVAILABLE
    case status.REPAIRING:
      return statusText.REPAIRING
    case status.OUT_OF_SERVICE:
      return statusText.OUT_OF_SERVICE
    case status.WATCHING:
      return statusText.WATCHING
    case status.ACCIDENT:
      return statusText.ACCIDENT
    case status.NO_DRIVER:
      return statusText.NO_DRIVER
    case status.IN_USE:
      return statusText.IN_USE
    default:
      return 'ไม่ระบุ'
  }
}

const downloadMonthlyreport = (setIsLoading, setShowModal, date) => {
  setIsLoading(true)
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/truck/monthlyreport/?selectedDate=${date}`,
  }).then((resp) => {
    FileDownload(resp.data, `พิมพ์รายงานการวิ่งของรถบรรทุก เดือน ${moment(date).format('MM-YYYY')}.xls`)
    setIsLoading(false)
    setShowModal(false)
  })
}

const downloadTruckReport = (setIsLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/truck/report`,
  }).then((resp) => {
    FileDownload(resp.data, `ข้อมูลรถบรรทุก วันที่ ${moment().format('DD')} ${monthConverter(moment().format('MM'))} ${parseInt(moment().format('YYYY'), 10) + 543}.xls`)
    setIsLoading(false)
  })
}

const Index = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [date, setDate] = useState(moment())
  const [showModal, setShowModal] = useState(false)
  const [changeTireModal, setChangeTireModal] = useState(false)
  const [repairExpenseModal, setRepairExpenseModal] = useState(false)
  const [fuelConsumptionRateModal, setFuelConsumptionRateModal] = useState(false)

  const menu = (
    <Menu
      onClick={(e) => {
        switch (e.key) {
          case 'truckReport': {
            setIsLoading(true)
            downloadTruckReport(setIsLoading)
            break
          }
          case 'showModal': {
            setShowModal(true)
            break
          }
          case 'changeTireModal': {
            setChangeTireModal(true)
            break
          }
          case 'repairExpenseModal': {
            setRepairExpenseModal(true)
            break
          }
          default: {
            break
          }
        }
      }}
    >
      <Menu.Item key='truckReport' disabled={!_.includes(window.perms, PERMISSION.EXPORT_TRUCK) || isLoading}>พิมพ์ข้อมูลรถบรรทุก</Menu.Item>
      <Menu.Item key='showModal' disabled={!_.includes(window.perms, PERMISSION.EXPORT_TRUCK) || isLoading}>พิมพ์รายงานการวิ่ง</Menu.Item>
      <Menu.Item key='changeTireModal'>พิมพ์รายงานค่ายาง</Menu.Item>
      <Menu.Item key='repairExpenseModal'>พิมพ์ค่าใช้จ่ายของการซ่อมรถบรรทุก</Menu.Item>
    </Menu>
  )

  return (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รถบรรทุกทั้งหมด</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between'>
        {
          window.role === 'SuperAdmin'
          && <Button
            text='แก้ไขอัตราการเผาผลาญน้ำมัน'
            onClick={() => {
              setFuelConsumptionRateModal(true)
            }}
            disabled={!_.includes(window.perms, PERMISSION.UPDATE_TRUCK)}
            margin='0 16px 0 0'
          />
        }
        <Dropdown overlay={menu}>
          <Button
            text='พิมพ์รายงาน'
            margin='0 16px 0 0'
            rightIcon
            icon='fas fa-chevron-down'
          />
        </Dropdown>
        <DynamicButtonLink link='/truck/add' condition={_.includes(window.perms, PERMISSION.CREATE_TRUCK)} props={{ text: 'เพิ่มรถบรรทุก' }}/>
        <Modal
          key='modal'
          title='พิมพ์รายงานการวิ่ง'
          visible={showModal}
          onOk={() => {
            downloadMonthlyreport(setIsLoading, setShowModal, date)
          }}
          onCancel={() => setShowModal(false)}
          okText='พิมพ์รายงาน'
          okButtonProps={{
            disabled: _.isUndefined(date),
            loading: isLoading,
          }}
          cancelButtonProps={{
            disabled: isLoading,
          }}
        >
          <Div display='flex' width='100%' justifyContent='center'>
            <DatePicker.MonthPicker size='large' placeholder='เลือกเดือน / ปี' defaultValue={moment()} onChange={e => setDate(e)}/>
          </Div>
        </Modal>
        <ChangeTireModal
          changeTireModal={changeTireModal}
          setChangeTireModal={setChangeTireModal}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
        <RepairExpenseModal
          repairExpenseModal={repairExpenseModal}
          setRepairExpenseModal={setRepairExpenseModal}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
        <FuelConsumptionRateModal
          fuelConsumptionRateModal={fuelConsumptionRateModal}
          setFuelConsumptionRateModal={setFuelConsumptionRateModal}
        />
      </Div>
    </Div>
    <TruckList/>
  </Div>
  )
}

export const TruckList = () => {
  const [current, setCurrent] = useState(0)
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [filtered, setFiltered] = useState([])
  return (
  <Wrapper overflow padding='0 0 40px 0' flex>
    <Query
      query={GET_TRUCK_LIST}
      fetchPolicy='cache-and-network'
      variables={{
        limit: 5,
        offset: current * 5,
        orderBy: sorted[0].desc ? 'DESC' : 'ASC',
        orderField: sorted[0].id,
        ...filtered,
      }}
    >
    {
      ({
        error, loading, data, refetch,
      }) => {
        if (error) return <p>เกิดข้อผิดพลาด</p>
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        const trucklist = data.TruckList.lists
        return (
          <Div margin='auto'>
            <ReactTable
              className='table'
              data={trucklist} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: false, refetch })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: `3px solid ${colorSelector(rowInfo.original.status)}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              noDataText='ไม่พบข้อมูล'
              page={current}
              pages={Math.ceil(data.TruckList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  switch (v.id) {
                    case 'driver.fullname':
                      Object.assign(newOjb, {
                        driver: { fullname: v.value },
                      })
                      break
                    case 'owner.nameTh':
                      Object.assign(newOjb, {
                        owner: {
                          ...filtered.owner,
                          nameTh: v.value,
                        },
                      })
                      break
                    case 'owner.type':
                      Object.assign(newOjb, {
                        owner: {
                          ...filtered.owner,
                          type: v.value,
                        },
                      })
                      break
                    case 'type.nameTh':
                      Object.assign(newOjb, {
                        type: { nameTh: v.value },
                      })
                      break
                    default:
                      Object.assign(newOjb, {
                        [v.id]: v.value,
                      })
                      break
                  }
                })
                setFiltered(newOjb)
                setCurrent(0)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }
    }
    </Query>
  </Wrapper>
  )
}

export default Index
